import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Common } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class CommonModule extends VuexModule {
    @Action
    [Common.getCategoryList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/category/show`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Common.uploadImg](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/image/upload`,values, {headers: {'Content-Type':'multipart/form-data'}})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}